import { useEffect } from "react"

export const SITE_URL = "https://www.wememberz.com"

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null
  if (!el) {
    el = document.createElement("meta")
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}

export function applyPageMeta(opts: { title?: string; description?: string; image?: string; path: string }) {
  const url = SITE_URL + (opts.path === "/" ? "/" : opts.path.replace(/\/$/, ""))
  if (opts.title) {
    document.title = opts.title
    setMeta("property", "og:title", opts.title)
    setMeta("name", "twitter:title", opts.title)
  }
  if (opts.description) {
    setMeta("name", "description", opts.description)
    setMeta("property", "og:description", opts.description)
    setMeta("name", "twitter:description", opts.description)
  }
  setMeta("property", "og:url", url)
  if (opts.image) {
    const imageUrl = opts.image.startsWith("http") ? opts.image : SITE_URL + opts.image
    setMeta("property", "og:image", imageUrl)
    setMeta("name", "twitter:image", imageUrl)
  }
  let canon = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null
  if (!canon) {
    canon = document.createElement("link")
    canon.rel = "canonical"
    document.head.appendChild(canon)
  }
  canon.href = url
}

export function usePageMeta(title: string | undefined, description: string | undefined, path: string) {
  useEffect(() => {
    applyPageMeta({ title, description, path })
  }, [title, description, path])
}

const HOME = {
  title: "Wememberz - Vos plus beaux souvenirs en albums photo",
  description:
    "Créez facilement vos albums photo personnalisés. Made in France, éco-responsable. Livraison offerte dès 50€. Conservez vos plus beaux souvenirs simplement.",
}

export const STATIC_META: Record<string, { title: string; description: string; image?: string }> = {
  "/": { ...HOME, image: "/images/social/accueil.jpg" },
  "/programme-fidelite": {
    title: "Programme fidélité et parrainage : points et récompenses | Wememberz",
    description: "Découvrez le programme fidélité Wememberz : parrainez vos proches, cumulez des points et débloquez des codes promo pour vos prochains albums photo.",
    image: "/images/social/accueil.jpg",
  },
  "/faq": {
    title: "FAQ - Questions fréquentes sur nos albums photo | Wememberz",
    description:
      "Création, formats, livraison, paiement, albums collaboratifs : toutes les réponses à vos questions sur les albums photo personnalisés Wememberz.",
    image: "/images/social/faq.jpg",
  },
  // /blog est exclu du prerender : la page est un fichier statique éditable
  // à la main (public/blog/index.html), recopié tel quel dans dist/.
  "/qui_sommes_nous": {
    title: "Qui sommes-nous ? L'histoire de Wememberz, albums Made in France",
    description:
      "Découvrez l'équipe Wememberz et notre mission : vous aider à imprimer vos souvenirs dans des albums photo collaboratifs, éco-responsables et fabriqués en France.",
  },
  "/cgv": {
    title: "Conditions générales de vente | Wememberz",
    description: "Consultez les conditions générales de vente des albums photo Wememberz : commande, paiement, livraison, rétractation et garanties.",
  },
  "/mentions_legales": {
    title: "Mentions légales | Wememberz",
    description: "Mentions légales du site Wememberz : éditeur, hébergement et informations juridiques.",
  },
  "/politique_confidentialite": {
    title: "Politique de confidentialité | Wememberz",
    description: "Comment Wememberz collecte, utilise et protège vos données personnelles et vos photos.",
  },
}